// extracted by mini-css-extract-plugin
module.exports = {"Modal":"modal_Modal__3psLG","CloseButton":"modal_CloseButton__1YYVM","OptionsButton":"modal_OptionsButton__8m5bG","Button":"modal_Button__3BDYb"};